import api from '../../utils/axios';

export default {
  namespaced: true,
  
  state: {
    cases: [],
    currentCase: null,
    loading: false,
    error: null
  },
  
  mutations: {
    SET_CASES(state, cases) {
      state.cases = cases;
    },
    SET_CURRENT_CASE(state, caseItem) {
      state.currentCase = caseItem;
    },
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  
  actions: {
    // 获取所有案例
    async fetchCases({ commit }) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get('/cases');
        commit('SET_CASES', response);
        return response;
      } catch (error) {
        commit('SET_ERROR', error.message || '获取案例列表失败');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 获取单个案例详情
    async fetchCaseById({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/cases/${id}`);
        commit('SET_CURRENT_CASE', response);
        return response;
      } catch (error) {
        commit('SET_ERROR', error.message || '获取案例详情失败');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    // 按标签搜索案例
    async searchCasesByTags({ commit }, tags) {
      commit('SET_LOADING', true);
      try {
        const response = await api.get(`/cases/search?tags=${tags}`);
        commit('SET_CASES', response);
        return response;
      } catch (error) {
        commit('SET_ERROR', error.message || '搜索案例失败');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  
  getters: {
    allCases: state => state.cases,
    currentCase: state => state.currentCase,
    isLoading: state => state.loading,
    error: state => state.error
  }
}; 